export default "__VITE_ASSET__BBcAuQ6e__"